import React, { useEffect, useState } from "react";
import { Input, Modal } from "antd";
import ImageUploadWithCrop from "../../CoreComponents/ImageUploadWithCrop";
import { createSection, updateSection } from "./api";
import { notify } from "./notify";
import { windowError } from "./sectionWindow";
import ShowBetweenField from "./ShowBetweenField";

const startingWindow = (section) => ({ from: (section && section.visible_from) || "", to: (section && section.visible_to) || "" });

const problemWith = (title, logo, shown) => {
  if (!title.trim()) return "Give the section a title";
  if (!logo) return "Add a logo";
  return windowError(shown.from, shown.to);
};

export default function SectionForm({ open, onClose, onSaved, placement, section, franchiseId }) {
  const [title, setTitle] = useState("");
  const [logo, setLogo] = useState("");
  const [shown, setShown] = useState(startingWindow(null));
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setTitle(section ? section.title : "");
    setLogo(section ? section.logo || "" : "");
    setShown(startingWindow(section));
  }, [open, section]);

  const save = async () => {
    const problem = problemWith(title, logo, shown);
    if (problem) return notify({ Status: false, Error: problem });
    setSaving(true);
    const fields = { title: title.trim(), visibleFrom: shown.from || null, visibleTo: shown.to || null };
    const result = section
      ? await updateSection(section.id, {
          ...fields, logo: typeof logo === "string" ? undefined : logo,
        })
      : await createSection({ ...fields, placement, logo, franchiseId });
    setSaving(false);
    if (notify(result, section ? "Section saved" : "Section created")) onSaved();
  };

  return (
    <Modal open={open} title={section ? "Edit section" : "Add section"} okText="Save" onOk={save}
      confirmLoading={saving} onCancel={onClose} destroyOnClose>
      <label className="d-block mb-1">Title</label>
      <Input value={title} maxLength={120} onChange={(e) => setTitle(e.target.value)} placeholder="Biryani Week" />
      <div className="mt-3">
        <ImageUploadWithCrop label="Logo" value={logo} onChange={(file) => setLogo(file || "")}
          aspectRatio={1} recommendedSizeText="200 × 200" compressMaxRes={200} required />
      </div>
      <ShowBetweenField from={shown.from} to={shown.to} onChange={setShown} />
    </Modal>
  );
}
